/**
 *
 * @des 登录模块
 *
 */

import { get, prefix } from './base';

export function companyLogin(params) {
  return get(`${prefix}passport/v1/companyLogin`, params);
}

// 退出
export function logout(params) {
  return get(`${prefix}passport/v1/logout`, params);
}
// 统一端登录
export function unifiedLogin(params) {
  return get(`${prefix}passport/v1/unifiedLogin`, params);
}
